webpackJsonp([13],{

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
/** Import frontoffice_app */

__webpack_require__(5);

var _ajax_handler = _interopRequireDefault(__webpack_require__(6));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @class LoginHandler
 */
var LoginHandler =
/*#__PURE__*/
function () {
  /**
   * @constructor
   */
  function LoginHandler() {
    _classCallCheck(this, LoginHandler);

    $('input[name="localTimeZone"]').val(Intl.DateTimeFormat().resolvedOptions().timeZone);

    this._listenLoginSubmit();
  }
  /**
   * login
   */


  _createClass(LoginHandler, [{
    key: "_listenLoginSubmit",
    value: function _listenLoginSubmit() {
      $("#ajax-login").on("click", function () {
        var data = {
          username: $("#username").val(),
          password: $("#password").val(),
          localTimeZone: $("#localTimeZone").val()
        };

        _ajax_handler.default.post('user/login', data).then(function (response) {
          if (response.success) {
            window.location.href = document.referrer;
          } else {
            $('#customer-login-error').html('Pogrešan e-mail ili lozinka');
          }
        });

        return false;
      });
    }
  }]);

  return LoginHandler;
}();
/** Start LoginHandler */


$(document).ready(function () {
  new LoginHandler();
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })

},[280]);


// WEBPACK FOOTER //
// frontoffice_login.js